import type { ExtraInfoProps } from "src/analytics/snowplowEntities";

const extraInfoDimensions = [
  "advertiserId",
  "campaignId",
  "companyIds",
  "creativeId",
  "creativeTemplateId",
  "isBackfill",
  "lineItemId",
  "responseIdentifier",
  "size",
  "sourceAgnosticCreativeId",
  "sourceAgnosticLineItemId",
  "yieldGroupIds",
] satisfies (keyof googletag.events.SlotRenderEndedEvent)[];

type Dimension = (typeof extraInfoDimensions)[number];
type DimensionsValue = googletag.events.SlotRenderEndedEvent[Dimension];

export function isSizeDimension(
  value: DimensionsValue,
): value is [number, number] {
  return (
    Array.isArray(value) &&
    value.length === 2 &&
    value.every((item) => typeof item === "number")
  );
}

export function getGptRenderedDimensions(
  event: googletag.events.SlotRenderEndedEvent,
) {
  const dimensions: ExtraInfoProps["dimensions"] = {};

  for (const dimension of extraInfoDimensions) {
    const value = event[dimension];

    // "size" is a special case where we split out the
    // array into standalone height & width values.
    if (dimension === "size" && isSizeDimension(value)) {
      const [width, height] = value;

      dimensions.height = String(height);
      dimensions.width = String(width);
    } else if (Array.isArray(value)) {
      dimensions[dimension] = value.map((item) => String(item));
    } else if (
      typeof value === "string" ||
      value === undefined ||
      value === null
    ) {
      dimensions[dimension] = value;
    } else {
      dimensions[dimension] = String(value);
    }
  }

  return dimensions;
}
